import React from 'react';
import './App.scss';
import {Routes, Route, Navigate} from "react-router-dom";
import {HomePage} from "./Pages/home-page/HomePage";
import BusinessEducation from "./Pages/business-education/BusinessEducation";
import AccountFinance from "./Pages/account-finance/AccountFinance";
import About from "./Pages/about/About";
import Registration from "./Pages/registration/Registration";
import AuthWrapper from "./components/auth-wrapper/AuthWrapper";
import Login from "./Pages/registration/login/Login";
import ForgotPassword from "./Pages/registration/forget-password/ForgotPassword";
import ResetPassword from "./Pages/registration/reset-password/ResetPassword";
import Events from "./Pages/events/Events";
import News from "./Pages/news/News";
import ViewNews from "./Pages/news/sections/view-news/ViewNews";
import PrivateRoute from "./auth/PrivateRoute";
import PublicRoute from "./auth/PublicRoute";
import Dashboard from "./Pages/app/dashboard/dashboard";
import {SideBar} from "./components";
import StartBusiness from "./Pages/app/business-education/start-business/StartBusiness";
import GrowBusiness from "./Pages/app/business-education/grow-business/GrowBusiness";
import PlanBusiness from "./Pages/app/business-education/plan-business/PlanBusiness";
import AppNewsList from "./Pages/app/news/AppNewsList";
import AppNews from "./Pages/app/news/AppNews";
import Business from "Pages/app/business/Business";
import AppEventsList from "./Pages/app/events/AppEventsList";
import AppEvent from "./Pages/app/events/AppEvent";
import Course from "./Pages/app/business-education/Course";

function App() {
    return (
        <div className="App">

            <Routes>
                <Route path="/"/>
                <Route index element={<HomePage/>}/>
                <Route path="business-education" element={<BusinessEducation/>}/>
                <Route path="finance" element={<AccountFinance/>}/>
                <Route path="about" element={<About/>}/>
                <Route path="events" element={<Events/>}/>
                <Route path="news" element={<News/>}>
                    <Route path=":newsId" element={<ViewNews/>}/>
                </Route>

                <Route path="/*" element={<PublicRoute><AuthWrapper/></PublicRoute>}>
                    <Route path={'registration'} element={<Registration/>}/>
                    <Route path="login" element={<Login/>}/>
                    <Route path="reset" element={<ResetPassword/>}/>
                    <Route path="forgot" element={<ForgotPassword/>}/>
                </Route>

                <Route path={"/app/*"} element={<PrivateRoute/>}>

                    <Route path="dashboard" element={<SideBar/>}>
                        <Route index element={<Dashboard/>}/>
                    </Route>

                    <Route path="business" element={<SideBar/>}>
                        <Route index element={<Business/>}/>
                    </Route>

                    <Route path="education" element={<SideBar/>}>
                        <Route index element={<Navigate to={'plan'}/>}/>
                        <Route path={"plan"} element={<PlanBusiness/>}/>
                        <Route path={"plan/:planId"} element={<Course/>}/>
                        <Route path={"start"} element={<StartBusiness/>}/>
                        <Route path={"start/:startId"} element={<Course/>}/>
                        <Route path={"grow"} element={<GrowBusiness/>}/>
                        <Route path={"grow/:growId"} element={<Course/>}/>
                    </Route>
                    <Route path="news" element={<SideBar/>}>
                        <Route index element={<Navigate to={'news'}/>}/>
                        <Route path={'news'} element={<AppNewsList/>}/>
                        <Route path={'news/:newsId'} element={<AppNews/>}/>
                        <Route path={'events'} element={<AppEventsList/>}/>
                        <Route path={'events/:eventId'} element={<AppEvent/>}/>
                    </Route>

                    <Route path="*" element={<div style={{height: "100vh"}}>Page not founds</div>}/>
                </Route>
                <Route path="*" element={<div>Page not found</div>}/>
            </Routes>
        </div>
    );
}

export default App;
